import { gql } from "@apollo/client";

const KeepEditDelta = gql`
  mutation UpdateQaQc($editId: BigInt!, $active: Boolean!) {
    updateQaqcByEditId(
      input: { qaqcPatch: { keepEdit: $active }, editId: $editId }
    ) {
      qaqc {
        isActive
      }
    }
  }
`;
const hash = "d8603a9cb6c0650aa957ef57cb811010a4e31e65632960fd9b842cbdf757dbf4";
export { KeepEditDelta, hash };
